<template>
  <modal-template
    ref="modal"
    size="lg"
    title="Imprimir fabricação"
    type-modal="print_manufacture_modal"
  >
    <div class="modal-content__main">
      <d-form @submit="print()">
        <d-row class="">
          <d-col md="4" xl="2" class="form-group">
            <label for="feInputDataInicio">Data de saída</label>
            <datepicker :model.sync="model.deadline"/>
          </d-col>
        </d-row>
      <template v-if="model.vertical.list.length">
        <h4>Vertical</h4>
        <!-- Blinds Vertical Table -->
        <d-form-row class="mt-2 mb-4 table-overflow">
          <table class="table table-striped table-bordered" role="table">
            <thead class="bg-light" role="rowgroup">
              <tr role="row">
                <th role="columnheader" class="text-center">ID</th>
                <th role="columnheader" class="text-center">Largura</th>
                <th role="columnheader" class="text-center">Altura</th>
                <th role="columnheader" class="text-center">Parapeito</th>
                <th role="columnheader" class="text-center">Qtd.</th>
                <th role="columnheader" class="text-center">Tecido</th>
                <th role="columnheader" class="text-center">Abertura</th>
                <th role="columnheader" class="text-center">Bandô</th>
                <th role="columnheader" class="text-center">Abas Bandô</th>
                <th role="columnheader" class="text-center">Vão</th>
                <th role="columnheader" class="text-center"></th>
              </tr>
            </thead>
            <tbody role="rowgroup">
              <tr role="row" v-for="(item, navItemId) in model.vertical.list" :key="navItemId">
                <td role="cell" class="td-1">
                  <span class="d-block mt-2 text-center">{{navItemId + 1}}</span>
                </td>
                <td role="cell" class="td-2">
                  <d-form-input
                    type="number"
                    placeholder="Largura"
                    v-model="item.width"
                    required
                  />
                </td>
                <td role="cell" class="td-2">
                  <d-form-input
                    type="number"
                    placeholder="Altura"
                    v-model="item.height"
                    required
                  />
                </td>
                <td role="cell" class="td-2">
                  <d-form-input
                    type="number"
                    placeholder="Parapeito"
                    v-model="item.parapet"
                    required
                  />
                </td>
                <td role="cell" class="td-2">
                  <input type="number" class="text-center form-control" placeholder="Qtd." min="1" v-model="item.quantity" required/>
                </td>
                <td role="cell" class="td-4">
                  <d-form-input
                    type="text"
                    placeholder="Tecido"
                    v-model="item.color"
                    required
                  />
                </td>
                <td role="cell" class="td-3">
                  <d-select v-model="item.opening" :options="opening" required></d-select>
                </td>
                <td role="cell" class="td-1 text-center">
                  <d-checkbox toggle @change="toggleCheckbox('vertical', navItemId, 'pelmet')" :checked="(item.pelmet == 1)" class="custom-toggle-sm d-inline"></d-checkbox>
                </td>
                <td role="cell" class="td-3">
                  <d-select v-model="item.pelmet_type" :options="pelmets" required></d-select>
                </td>
                <td role="cell" class="td-1 text-center">
                  <d-checkbox toggle @change="toggleCheckbox('vertical', navItemId, 'gap')" :checked="(item.gap == 1)" class="custom-toggle-sm d-inline"></d-checkbox>
                </td>
                <td role="cell" class="td-1 buttons">
                  <i class="fas fa-plus text-success" @click="addRow('vertical')" v-if="navItemId+1 == model.vertical.list.length"></i>
                  <i class="fas fa-minus text-danger" @click="removeRow('vertical', navItemId)"></i>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="11" class="p-0">
                  <textarea v-model="model.vertical.comments" :rows="5" class="form-control border-0"></textarea>
                </td>
              </tr>
            </tfoot>
          </table>

        </d-form-row>
      </template>
      <template v-if="model.roller.list.length">
        <h4>Rolô</h4>
        <!-- Blinds Vertical Table -->
        <d-form-row class="mt-2 mb-4 table-overflow">
          <table class="table table-striped table-bordered" role="table">
            <thead class="bg-light" role="rowgroup">
              <tr role="row">
                <th role="columnheader" class="text-center">ID</th>
                <th role="columnheader" class="text-center">Largura</th>
                <th role="columnheader" class="text-center">Altura</th>
                <th role="columnheader" class="text-center">Parapeito</th>
                <th role="columnheader" class="text-center">Qtd.</th>
                <th role="columnheader" class="text-center">Tecido</th>
                <th role="columnheader" class="text-center">Tubo</th>
                <th role="columnheader" class="text-center">Comando</th>
                <th role="columnheader" class="text-center">Enrolamento</th>
                <th role="columnheader" class="text-center">Bandô</th>
                <th role="columnheader" class="text-center">Motor</th>
                <th role="columnheader" class="text-center">Volts</th>
                <th role="columnheader" class="text-center">Redutor</th>
                <th role="columnheader" class="text-center">Vão</th>
                <th role="columnheader" class="text-center"></th>
              </tr>
            </thead>
            <tbody role="rowgroup">
              <tr role="row" v-for="(item, navItemId) in model.roller.list" :key="navItemId">
                <td role="cell" class="td-1">
                  <span class="d-block mt-2 text-center">{{navItemId + 1}}</span>
                </td>
                <td role="cell" class="td-2">
                  <d-form-input
                    type="number"
                    placeholder="Largura"
                    v-model="item.width"
                    required
                  />
                </td>
                <td role="cell" class="td-2">
                  <d-form-input
                    type="number"
                    placeholder="Altura"
                    v-model="item.height"
                    required
                  />
                </td>
                <td role="cell" class="td-2">
                  <d-form-input
                    type="number"
                    placeholder="Parapeito"
                    v-model="item.parapet"
                    required
                  />
                </td>
                <td role="cell" class="td-2">
                  <input type="number" class="text-center form-control" step="1" placeholder="Qtd." min="1" v-model="item.quantity" required/>
                </td>
                <td role="cell" class="td-4">
                  <d-form-input
                    type="text"
                    placeholder="Tecido"
                    v-model="item.color"
                    required
                  />
                </td>
                <td role="cell" class="td-3">
                  <d-select v-model="item.thickness" :options="thicknesses" required></d-select>
                </td>
                <td role="cell" class="td-3">
                  <d-select v-model="item.engineSide" required>
                    <option value="right">Direita</option>
                    <option value="left">Esquerda</option>
                  </d-select>
                </td>
                <td role="cell" class="td-3">
                  <d-select v-model="item.furl" required>
                    <option value="normal">Normal</option>
                    <option value="inverted">Invertido</option>
                  </d-select>
                </td>
                <td role="cell" class="td-1 text-center">
                  <d-checkbox toggle @change="toggleCheckbox('roller', navItemId, 'pelmet')" :checked="(item.pelmet == 1)" class="custom-toggle-sm d-inline"></d-checkbox>
                </td>
                <td role="cell" class="td-1 text-center">
                  <d-checkbox toggle @change="toggleCheckbox('roller', navItemId, 'reducer')" :checked="(item.reducer == 1)" class="custom-toggle-sm d-inline"></d-checkbox>
                </td>
                <td role="cell" class="td-3">
                  <d-form-input
                    type="text"
                    placeholder="Volts"
                    v-model="item.engineVolts"
                    required
                  />
                </td>
                <td role="cell" class="td-1 text-center">
                  <d-checkbox toggle @change="toggleCheckbox('roller', navItemId, 'hasEngine')" :checked="(item.hasEngine == 1)" class="custom-toggle-sm d-inline"></d-checkbox>
                </td>
                <td role="cell" class="td-1 text-center">
                  <d-checkbox toggle @change="toggleCheckbox('roller', navItemId, 'gap')" :checked="(item.gap == 1)" class="custom-toggle-sm d-inline"></d-checkbox>
                </td>
                <td role="cell" class="td-1 buttons">
                  <i class="fas fa-plus text-success" @click="addRow('roller')" v-if="navItemId+1 == model.roller.list.length"></i>
                  <i class="fas fa-minus text-danger" @click="removeRow('roller', navItemId)"></i>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="15" class="p-0">
                  <textarea v-model="model.roller.comments" :rows="5" class="form-control border-0"></textarea>
                </td>
              </tr>
            </tfoot>
          </table>

        </d-form-row>
      </template>
      </d-form>
    </div>

    <div slot="actions" class="modal-content__control" >
      <d-button
        type="button"
        @click="print()"
        class="btn btn-sm btn-primary"
      >Imprimir</d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Datepicker from '_shared/Datepicker.vue';
import ModalTemplate from '_shared/Modal.vue';
import QuotationService from '_services/rest/modules/quotation';
import { openPdf, catchPdf } from '_utils/require';
import { getDateISO } from '_utils';
import { OPENING, PELMETS, _OPEN_MODAL_, THICKNESSES, BLINDS } from '../QuotationModel';

const modelBlinds = typeId => ({ ...BLINDS, ...{ blinds_type_id: typeId } });
const MODEL = {
  deadline: null,
  vertical: { list: [modelBlinds(5)], comments: '' },
  roller: { list: [modelBlinds(3)], comments: '' },
};

export default {
  name: 'print-manufacture-modal',
  mixins: [],
  components: {
    Datepicker,
    ModalTemplate,
  },
  props: {},
  data() {
    return {
      model: MODEL,
      opening: OPENING,
      pelmets: PELMETS,
      quotation: null,
      thicknesses: THICKNESSES,
    };
  },
  computed: {
    blindsTypes() {
      const { blindsTypes } = this.$store.state.quotation;
      const typeEmpty = { id: null, slug: '', name: 'Selecione um tipo' };
      if (blindsTypes) {
        return [{ ...typeEmpty }, ...blindsTypes];
      }
      return [{ ...typeEmpty }];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getBlindsTypes',
    ]),
    addRow(type) {
      const typeId = (type === 'vertical') ? 5 : 3;
      this.model[type].list.push(modelBlinds(typeId));
    },
    getType() {
      if (this.$store.state.quotation.blindsTypes == null) {
        this.setToggle({ type: 'progress', bool: true });
        this.getBlindsTypes()
          .then(() => {
            this.setToggle({ type: 'progress', bool: false });
          });
      }
    },
    print() {
      if (this.model.deadline) {
        this.setToggle({ type: 'progress', bool: true });
        this.model.deadline = getDateISO(this.model.deadline);
        QuotationService.printManufactureBlinds(this.model, this.quotation.id)
          .then(response => {
            openPdf(response);
            this.setToggle({ type: 'print_manufacture_modal', bool: false });
          })
          .catch(error => this.activeAlert({ message: catchPdf(error.message), theme: 'danger' }))
          .finally(() => this.setToggle({ type: 'progress', bool: false }));
      } else {
        this.activeAlert({ message: 'A data de saída é obrigatória', theme: 'danger' });
      }
    },
    removeRow(type, index) {
      this.model[type].list.splice(index, 1);
      if (this.model[type].list.length === 0) {
        this.addRow(type);
      }
    },
    toggleCheckbox(type, index, field) {
      const value = (this.model[type].list[index][field]) ? 0 : 1;
      this.$set(this.model[type].list[index], field, value);
      return field;
    },
  },
  mounted() {
    Events.$on(_OPEN_MODAL_, ({ quotation, type }) => {
      if (type === 'print_manufacture_modal') {
        QuotationService.getManufactureBlinds(quotation.id)
          .then(response => {
            this.quotation = quotation;
            this.model = { ...MODEL, ...response };
            this.model.vertical.comments = (this.model.vertical.comments) ? this.model.vertical.comments.join('\n') : '';
            this.model.roller.comments = (this.model.roller.comments) ? this.model.roller.comments.join('\n') : '';
          });
      }
    });
    this.getType();
  },
};
</script>

<style lang="scss">
@media (min-width: 992px) {
  .modal-lg {
    max-width: 1340px!important;
  }
}
</style>
<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}

.td {
  &-1 {
    min-width: 10px;
    width: 3%;
  }
  &-2 {
    min-width: 20px;
    width: 7%;
  }
  &-3 {
    min-width: 30px;
    width: 10%;
  }
  &-4 {
    min-width: 60px;
    width: 20%;
  }
}

.buttons {
  text-align: center;
  vertical-align: middle;
  .btn-sm { padding: 0.4rem 0.7rem; }
  i { cursor: pointer; }
}
</style>
